export const VENDOR_CHOICES = [
  'connect',
  'certn',
  'Equifax',
  'Samba',
  'PenDOT',
  'I3Screen',
  'Clearinghouse',
  'Sunshine',
  'WSS',
  'IEI',
  'Runner',
  'Armantek',
  'Worcs',
] as const;

export const VENDOR_LINK_COLOR = '#7364DB';
// Lifted so the same purple clears 4.5:1 on the night-mode row.
export const VENDOR_LINK_COLOR_DARK = '#9b8ef2';
export const EDIT_CHECK_COLOR = '#1976d2';
export const DISABLED_CONTROL_COLOR = '#9A9AAF';
export const NEEDS_ORDER_ID_TOOLTIP = 'needs Order ID to enable';

const portalUrl = {
  connect: (orderId: string) => `https://connect.sjvassoc.com/orders/${encodeURIComponent(orderId)}`,
  certn: (orderId: string) => `https://turn.certn.co/hr/applications/${encodeURIComponent(orderId)}`,
  clearinghouse: (orderId: string) => `https://clearinghouse.fmcsa.dot.gov/Query/Result/${encodeURIComponent(orderId)}`,
};

export const portalHref = (vendor: string, orderId: string) => {
  const build = portalUrl[vendor.trim().toLowerCase() as keyof typeof portalUrl];
  const id = orderId.trim();
  if (!build || !id) return null;
  return build(id);
};

export const hasVendorPortal = (vendor: string) =>
  Boolean(portalUrl[vendor.trim().toLowerCase() as keyof typeof portalUrl]);
